var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ],
      staticClass: "Edit"
    },
    [
      _c(
        "el-header",
        { staticClass: "Edit-header" },
        [
          _c("el-page-header", {
            attrs: { content: _vm.title },
            on: { back: _vm.close }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-main",
        { staticClass: "Edit-main" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "200px"
              }
            },
            [
              _vm.isSspUser
                ? _c(
                    "el-form-item",
                    { attrs: { label: "所属广告主", prop: "advertiserId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { disabled: _vm.isModel === 2 },
                          on: {
                            change: function($event) {
                              _vm.form.putUnitName = ""
                              _vm.form.planId = ""
                              _vm.getPlanList()
                            }
                          },
                          model: {
                            value: _vm.form.advertiserId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "advertiserId", $$v)
                            },
                            expression: "form.advertiserId"
                          }
                        },
                        _vm._l(_vm.user, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.advertiserName,
                              value: item.advertiserId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "投放单元名称", prop: "putUnitName" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.putUnitName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "putUnitName", $$v)
                      },
                      expression: "form.putUnitName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "代码位类型", prop: "slotType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.isModel === 2 },
                      model: {
                        value: _vm.form.slotType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "slotType", $$v)
                        },
                        expression: "form.slotType"
                      }
                    },
                    _vm._l(_vm.myOption.slotType, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "代码位定向", prop: "assignSlot" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      "show-word-limit": "",
                      placeholder: "多个用英文逗号隔开"
                    },
                    model: {
                      value: _vm.form.assignSlot,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "assignSlot", $$v)
                      },
                      expression: "form.assignSlot"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  class: { "is-error": _vm.packageInputError },
                  staticStyle: { width: "65vw" },
                  attrs: { label: "媒体包名定向", prop: "includePackages" }
                },
                [
                  _vm._l(_vm.includePackageArray, function(tag, index) {
                    return _c(
                      "el-tag",
                      {
                        key: index,
                        attrs: {
                          size: "mini",
                          closable: "",
                          "disable-transitions": false
                        },
                        on: {
                          close: function($event) {
                            return _vm.removePackage(tag)
                          }
                        }
                      },
                      [_vm._v(_vm._s(tag))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.packageInputVisible
                    ? _c("el-input", {
                        ref: "packageInputRef",
                        staticClass: "input-new-tag",
                        staticStyle: { width: "180px" },
                        attrs: {
                          size: "small",
                          placeholder: "com.huawei.appmarket"
                        },
                        on: { blur: _vm.handlePackageInputConfirm },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handlePackageInputConfirm.apply(
                              null,
                              arguments
                            )
                          }
                        },
                        model: {
                          value: _vm.packageInputValue,
                          callback: function($$v) {
                            _vm.packageInputValue = $$v
                          },
                          expression: "packageInputValue"
                        }
                      })
                    : _c("el-button", {
                        staticClass: "button-new-tag",
                        attrs: { size: "small", icon: "el-icon-plus" },
                        on: { click: _vm.showPackageInput }
                      }),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "light",
                        content:
                          "包名：支持字母、数字、下划线、点号。不支持数字开头, 且至少要满足格式：xxx.yyy",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  class: { "is-error": _vm.brandInputError },
                  staticStyle: { width: "65vw" },
                  attrs: { label: "品牌定向", prop: "includeBrands" }
                },
                [
                  _vm._l(_vm.includeBrandArray, function(tag, index) {
                    return _c(
                      "el-tag",
                      {
                        key: index,
                        attrs: {
                          size: "mini",
                          closable: "",
                          "disable-transitions": false
                        },
                        on: {
                          close: function($event) {
                            return _vm.removeBrand(tag)
                          }
                        }
                      },
                      [_vm._v(_vm._s(tag))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.brandInputVisible
                    ? _c("el-input", {
                        ref: "brandInputRef",
                        staticClass: "input-new-tag",
                        attrs: { size: "small", placeholder: "HUAWEI" },
                        on: { blur: _vm.handleBrandInputConfirm },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleBrandInputConfirm.apply(
                              null,
                              arguments
                            )
                          }
                        },
                        model: {
                          value: _vm.brandInputValue,
                          callback: function($$v) {
                            _vm.brandInputValue = $$v
                          },
                          expression: "brandInputValue"
                        }
                      })
                    : _c("el-button", {
                        staticClass: "button-new-tag",
                        attrs: { size: "small", icon: "el-icon-plus" },
                        on: { click: _vm.showBrandInput }
                      }),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "light",
                        content:
                          "品牌：支持字母、数字、下划线、中划线、空格。不支持数字开头",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  class: { "is-error": _vm.modelInputError },
                  staticStyle: { width: "65vw" },
                  attrs: { label: "机型定向", prop: "includeModels" }
                },
                [
                  _vm._l(_vm.includeModelArray, function(tag, index) {
                    return _c(
                      "el-tag",
                      {
                        key: index,
                        attrs: {
                          size: "mini",
                          closable: "",
                          "disable-transitions": false
                        },
                        on: {
                          close: function($event) {
                            return _vm.removeModel(tag)
                          }
                        }
                      },
                      [_vm._v(_vm._s(tag))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.modelInputVisible
                    ? _c("el-input", {
                        ref: "modelInputRef",
                        staticClass: "input-new-tag",
                        attrs: { size: "small", placeholder: "Mate 30 Pro" },
                        on: { blur: _vm.handleModelInputConfirm },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleModelInputConfirm.apply(
                              null,
                              arguments
                            )
                          }
                        },
                        model: {
                          value: _vm.modelInputValue,
                          callback: function($$v) {
                            _vm.modelInputValue = $$v
                          },
                          expression: "modelInputValue"
                        }
                      })
                    : _c("el-button", {
                        staticClass: "button-new-tag",
                        attrs: { size: "small", icon: "el-icon-plus" },
                        on: { click: _vm.showModelInput }
                      }),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "light",
                        content: "机型：支持字母、数字、下划线、中划线、空格。",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "投放计划", prop: "planId" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.planId,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "planId", $$v)
                        },
                        expression: "form.planId"
                      }
                    },
                    _vm._l(_vm.planData, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.planName, value: item.planId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "流量类型", prop: "flowType" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.flowType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "flowType", $$v)
                        },
                        expression: "form.flowType"
                      }
                    },
                    _vm._l(_vm.myOption.flowType, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "控制频次", prop: "isLimit" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.isLimit,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "isLimit", $$v)
                        },
                        expression: "form.isLimit"
                      }
                    },
                    _vm._l(_vm.isLimitData, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.isLimit !== 0
                ? [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "500px" },
                        attrs: {
                          label: "每人每天看到X次后不再展现",
                          prop: "showLimit"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "text", "show-word-limit": "" },
                          on: {
                            input: function($event) {
                              return _vm.integer($event, "showLimit")
                            }
                          },
                          model: {
                            value: _vm.form.showLimit,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "showLimit", $$v)
                            },
                            expression: "form.showLimit"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "500px" },
                        attrs: {
                          label: "每人每天点击X次后不再展现",
                          prop: "clickLimit"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "text", "show-word-limit": "" },
                          on: {
                            input: function($event) {
                              return _vm.integer($event, "clickLimit")
                            }
                          },
                          model: {
                            value: _vm.form.clickLimit,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "clickLimit", $$v)
                            },
                            expression: "form.clickLimit"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "应用广告只下发已安装用户",
                    prop: "assignInstallPkg"
                  }
                },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.form.assignInstallPkg,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "assignInstallPkg", $$v)
                      },
                      expression: "form.assignInstallPkg"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "应用广告只下发未安装用户",
                    prop: "assignUninstallPkg"
                  }
                },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.form.assignUninstallPkg,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "assignUninstallPkg", $$v)
                      },
                      expression: "form.assignUninstallPkg"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "备注", prop: "remark" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("form")
                        }
                      }
                    },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _vm.isModel !== 2
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.resetForm("form")
                            }
                          }
                        },
                        [_vm._v("重置")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53cf8175", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53cf8175","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/unit/Edit.vue
// module id = npDK
// module chunks = 1